import React from 'react';

/**
 * ModalCloseButton component for consistent close button styling
 * Provides consistent positioning and accessibility
 */
const ModalCloseButton = ({ 
  onClose, 
  className = '',
  ariaLabel = 'Close',
  ...props 
}) => {
  return (
    <button
      className={`sticky top-3 z-10 ml-auto -mr-1 flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-xl font-bold text-text-muted transition-colors hover:text-text-primary focus:outline-none focus:ring-2 focus:ring-primary ${className}`}
      onClick={onClose}
      aria-label={ariaLabel}
      {...props}
    >
      &times;
    </button>
  );
};

export default ModalCloseButton;
